module.exports = __webpack_public_path__ + "static/media/icon.6e7dcbab.svg";